import request from "superagent";
import {
  createAuthInterceptor,
  createBaseInterceptor
} from "./plugins/compositePlugin";

// Re-export constant for backward compatibility
export { UNAUTHORIZED_EVENT } from "./constants";

// Re-export types for backward compatibility
export type {
  ErrorHandlingConfig,
  SuperAgentRequestWithConfig
} from "./plugins/types";

export const baseApiRequest = {
  get: (url: string) => request.get(url).use(createBaseInterceptor()),
  post: (url: string) => request.post(url).use(createBaseInterceptor()),
  put: (url: string) => request.put(url).use(createBaseInterceptor()),
  patch: (url: string) => request.patch(url).use(createBaseInterceptor()),
  delete: (url: string) => request.delete(url).use(createBaseInterceptor()),
  del: (url: string) => request.del(url).use(createBaseInterceptor())
};

export const apiRequest = {
  get: (url: string) => request.get(url).use(createAuthInterceptor()),
  post: (url: string) => request.post(url).use(createAuthInterceptor()),
  put: (url: string) => request.put(url).use(createAuthInterceptor()),
  patch: (url: string) => request.patch(url).use(createAuthInterceptor()),
  delete: (url: string) => request.delete(url).use(createAuthInterceptor()),
  del: (url: string) => request.del(url).use(createAuthInterceptor())
};
